import type { AccountRecord } from '@libs/data-access/entities'
import { usePlanningTranslation } from '@libs/utils/translations'
import type { RestModel } from '@spa/scenes/Plannings/redux/models/Rest'
import type { ShiftModel } from '@spa/scenes/Plannings/redux/models/Shift'
import React from 'react'
import type { FC } from 'react'

import CardInfo from '../../../../Card/CardInfo'

import { getShiftDuration } from './getShiftDuration'

type Props = {
  shift: ShiftModel
  rest: RestModel
  account: AccountRecord
}
const ShiftDuration: FC<Props> = ({ shift, rest, account }) => {
  const { t } = usePlanningTranslation()
  const duration = getShiftDuration({ shift, account, rest })

  return (
    <CardInfo.Content>
      {t('weekly.card.duration', { duration })}
    </CardInfo.Content>
  )
}

export default ShiftDuration
